import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import { MessageDescriptor } from '@lingui/core';
import { Trans } from '@lingui/macro';
import isString from 'lodash-es/isString';
import styled from 'styled-components';

import CalloutBadgeStyle from './CalloutBadge.constants';

type StyledBadgeProps = {
  calloutBadgeStyle: CalloutBadgeStyle;
};
const Badge = styled.span<StyledBadgeProps>`
  ${(props) => props.calloutBadgeStyle.toString()};
`;
export type Props = {
  value: ReactNode | MessageDescriptor;
  calloutBadgeStyle: CalloutBadgeStyle;
};

const isUntranslated = (value: ReactNode | MessageDescriptor): value is MessageDescriptor => {
  return true;
};

const CalloutBadge = ({ value, ...other }: Props): ReactElement => {
  let content;

  // handle translation objects passed to props.value
  if (value && isUntranslated(value) && isString(value.id) && value.id.length > 0) {
    content = <Trans id={value.id} />;
  } else {
    content = value;
  }

  return <Badge {...other}>{content}</Badge>;
};

CalloutBadge.defaultProps = {
  calloutBadgeStyle: CalloutBadgeStyle.DEFAULT,
};
CalloutBadge.Styles = CalloutBadgeStyle;
export default CalloutBadge;
